import { useAntDesignTheme } from './useAntDesignTheme';
import { createReportComponentOptions } from './reportComponents/reportComponentOptions';
import { componentTileConstraints, tileVariables, TileConstraints } from './reportComponents/tileConstraints';

export type { TileConstraints };

export const useReportComponents = () => {
    const { token } = useAntDesignTheme();
    const allReportComponents = createReportComponentOptions(token);

    return { allReportComponents, tileVariables, componentTileConstraints };
};
